(function () {
	"use strict";

	function Projectile(world, x, y, container, sprite)
	{
		this.Container_constructor();
		this.mouseEnabled = false;
		this.mainView = null;
		this.allowUserControl = true;
		this.targetY = -1;
		this.world = world;
		this.invincibleTimer = 0;
		this.beginReset = false;
		this.ballX = 0;
		this.ballY = 0;
		this.tween = null;
		this.timer = 0;
		this.physicsData = {
			"spriteRegX": 38,
			"spriteRegY": 38,
			"fixtures": [
				{
					"density": 20,
					"friction": 0.5,
					"restitution": 0.7,
					"categoryBits": 1,
					"maskBits": 65535,
					"groupIndex": 0,
					"isSensor": false,
					"userData": "bulletObjectA",
					"fixtureType": "CIRCLE",
					"center": [0 ,0.008],
					"radius": 10
				}
			]
		};

		this.init(world, x, y, container, sprite);
	}

	var p = createjs.extend(Projectile, cjs.Container);

	p.init = function (world, x, y, container, spriteObject)
	{
		var physicsData = this.physicsData;
		var sprite = new cjs.Sprite(cm.Assets.lib.junkSS, spriteObject).center().set({ mouseEnabled: false });
		sprite.snapToPixel = false;
		sprite.framerate = 24;
		var scaleNum = 0.4;
		if(spriteObject === "bottle" || spriteObject === "stoll" || spriteObject === "styrofoam-container" || spriteObject === "milk")
			scaleNum = 0.2;
		sprite.scaleX = scaleNum;
		sprite.scaleY = scaleNum;
		this.displayObject = sprite;
		this.displayObject.visible = false;
		container.addChildAt(this.displayObject, 5);

		this.body = this.buildBodyFromData(physicsData, world, b2.b2Body.b2_dynamicBody, false);
		this.body.SetPosition(new b2.b2Vec2(x / b2.b2Scale, y / b2.b2Scale));
		this.ballX = x;
		this.ballY = y;
	};

	p.launchBall = function (sqrt, atan)
	{
		this.body.SetLinearVelocity(new b2.b2Vec2(-sqrt * Math.cos(atan) / 2, -sqrt * Math.sin(atan) / 2));
		this.body.SetAngularVelocity(-sqrt * Math.cos(atan) / 6);
		cjs.Tween.get(this.displayObject).wait(200).set({visible:true});
	};


	p.bringToCenter = function (callback)
	{
		this.targetY = this.body.GetPosition().y * b2.b2Scale;
		cjs.Tween.get(this).to({ targetY: 0 }, 2000, cjs.Ease.quadOut).call(callback);
	};

	p.buildBodyFromData = function( data, world, bodyType , bool)
	{
		var fixtures = data.fixtures;
		var body;
		var bodyDef = new b2.b2BodyDef();
		bodyDef.type = bodyType;
		bodyDef.userData = this;
		if(bool)
			bodyDef.bullet = true;

		// create the body
		body = world.CreateBody(bodyDef);

		// prepare fixtures
		for (var i = 0; i < fixtures.length; i++) {
			var fixture = fixtures[i];
			var fixtureDef = new b2.b2FixtureDef();
			fixtureDef.density = fixture.density;
			fixtureDef.friction = fixture.friction;
			fixtureDef.restitution = fixture.restitution;
			fixtureDef.filter.categoryBits = fixture.categoryBits;
			fixtureDef.filter.maskBits = fixture.maskBits;
			fixtureDef.filter.groupIndex = fixture.groupIndex;
			fixtureDef.isSensor = fixture.isSensor;
			if(fixture.userData) fixtureDef.userData = fixture.userData;

			if (fixture.fixtureType === "POLYGON") {
				var polygons = fixture.polygons;
				for (var p = 0; p < polygons.length; p++) {
					var vertices = [];
					for (var m = 0; m < polygons[p].length; m++) {
						vertices.push(new b2.b2Vec2(polygons[p][m][0] / b2.b2Scale, polygons[p][m][1] / b2.b2Scale));
					}
					var polygonShape = new b2.b2PolygonShape();
					polygonShape.SetAsArray(vertices, vertices.length);
					fixtureDef.shape = polygonShape;

					body.CreateFixture(fixtureDef);
				}
			} else if (fixture.fixtureType === "CIRCLE") {
				var circleShape = new b2.b2CircleShape(fixture.radius / b2.b2Scale);
				circleShape.SetLocalPosition(new b2.b2Vec2(fixture.center[0] / b2.b2Scale, fixture.center[1] / b2.b2Scale));
				fixtureDef.shape = circleShape;
				body.CreateFixture(fixtureDef);
			}
		}

		return body;
	};

	p.update = function()
	{
		var body, pos, vel, angle;
		if(this.allowUserControl) {
			body = this.body;
			pos = body.GetPosition();
			vel = body.GetLinearVelocity();
			angle = body.GetAngle();
			this.displayObject.x = pos.x * b2.b2Scale;
			this.displayObject.y = pos.y * b2.b2Scale;
			this.displayObject.rotation = Math.toDeg(angle);
			this.timer++;
			if(this.displayObject.x > 2000 || this.displayObject.x < -2000 || this.timer > 200)
				this.kill();
		}
	};

	p.kill = function ()
	{
		this.allowUserControl = false;
		cm.ViewControl.current.removeChild(this.displayObject);
		cm.ViewControl.current.projectile = null;
		cm.ViewControl.current.isShoot = false;
		if(cm.ViewControl.current.cannonImage)
			cm.ViewControl.current.cannonImage.visible = true;

		cm.ViewControl.current.callCannonImageScale();
		if(cm.ViewControl.current.shotsFired > 4){
			cm.ViewControl.current.binCorrect();
		}

		this.displayObject = null;
		cjs.Tween.removeTweens(this);
		this.world.DestroyBody(this.body);
	};

	cm.Projectile = cjs.promote(Projectile, "Container");
})();